import Swiper from "swiper";

const initViewedComponentSlider = () => {
    const components = Array.from(document.querySelectorAll('.viewed-products'));

    components.forEach(block => {
        if (block.inited) {
            return;
        }
        block.inited = true;

        new Swiper(block, {
            speed: 1000,
            spaceBetween: 2,
            breakpoints: {
                // mobile + tablet - 320-990
                320: {
                    slidesPerView: 2
                },
                // desktop >= 991
                1200: {
                    slidesPerView: 5
                }
            }
        });
    });
};

initViewedComponentSlider();

export default initViewedComponentSlider;
